import styled from "styled-components";

export const Div = styled.div`
margin-left:${({ marginLeft }) => (marginLeft ? marginLeft : 0)};
margin-top:${({ marginTop }) => (marginTop ? marginTop : "10px")};
${props => props.logo && `
    width:50%;
    margin:0 auto;
    & img{
        width:100%;
    }
`}
${props => props.communityHome && `
    flex:1;
`}
${props => props.flexdiv && `
    display: flex;
    @media screen and (max-width: 600px){
        width: 100%;
      }`
    }
${props => props.flexdiv1 && `
    display: flex;
    margin-top: 3px;
`
    }
${props => props.flexdesc && `
    max-width:43vw;
    overflow-x: hidden;
    @media screen and (max-width: 600px){
        max-width:93vw;
        overflow-x: hidden;
      }`
    }
${props => props.phoneflexdiv && `
    display: flex;
    margin-top: 12px;
    @media screen and (max-width: 600px){
        flex-direction:column;
      }`
    }
${props => props.flexdiv2 && `
    display: flex;
    margin-top: 12px;
    @media screen and (max-width: 600px){
        flex-direction:column;
      }`
    }
${props => props.flexcurrency && `
    @media screen and (max-width: 600px){
        position:relative;
        margin: auto;
        margin-top: 3%;
      }`
    }
${props => props.draftSaveButton && `
marginLeft: "33%";
`
}
${props => props.fulldiv && `
    height: 100vh;
    width:100vw;
 `
}
${props => props.sponsorchild && `
    display: flex;
    margin-left: 15px;
    margin-top: 14px;
 `
}
${props => props.statusModal && `
    display: flex;
    margin-left: 8%;
    margin-top: 7%;
    margin-bottom:3%;
    @media screen and (max-width: 600px){
        margin-left:3%;
      }`
}
${props => props.MessageModal && `
    display: flex;
    margin-left: 3%;
    margin-top: 4%;
    margin-bottom:5%;
    @media screen and (max-width: 600px){
        margin-left:3%;
      }`
}
${props => props.downloadmodaldiv && `
    display: flex;
    margin-left: 2%;
    margin-top: 3%;
    @media screen and (max-width: 600px){
        margin-top: 8%;
      }`
}
${props => props.sharemodaldiv && `
    display: flex;
    padding: 0 5% 5% 5%;
    width: 100%;
    margin-top: -5px;
    @media screen and (max-width: 600px){
        flex-direction:column;
        width:100vw;
        height:25vh;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait){
        flex-direction:row;
        width: 100%;
        padding: 1rem;
    }
 `
}
${props => props.referModal && `
    padding: 5%;
`}
${props => props.sponsorchildId && `
    display: flex;
    margin-left: 65px;
    margin-top: 7px;
 `
}
${props => props.sponsorcommunity && `
    display: flex;
    margin-left: 65px;
    margin-top: 11px;
    margin-right: 20px;
    @media only screen and (min-width: 1200px) and (max-width:1400px) {
        margin-right: 0px;
    }`
}
${props => props.communityheader && `
    z-index: 9;
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: row;
 `
}
${props => props.communityStationHeader && `
    z-index: 9;
    position: relative;
    width: 100%;
    @media screen and (max-width: 1400px){
        top: -8%;
      }
    top: -5%;
 `
}
${props => props.connectHeader && `
    z-index: 1;
    position: relative;
    width: 100%;
    top: -5%;
    @media screen and (max-width: 850px){
        position: absolute;
        top: 0%;
      }
    @media screen and (min-width: 821px) and (max-width: 1400px){
        top: -8%;
      }
 `
}
${props => props.giftCommunityStation && `
    @media screen and (max-width: 1400px){
        top: -8%;
    }
    top: -5%;
 `
}
${props => props.communityheaderLogo && `
    left: 28px;
    top: 5px;
    @media screen and (max-width: 740px){
        & img {
            --size: 100%;
            --aspect-ratio: 1.5;
            width: var(--size);
            max-width: 32px;
            max-height: 32px;
            object-fit: cover;
        } 
    } 
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        & img {
            max-height: 50px;
            width: max-content;
            padding-right: 6px;
            margin-bottom: 6px;
        }
    }   
 `
}
${props => props.menudiv && `
    float:right;
    z-index: 1;
    position: relative;
    display: flex;
    @media screen and (max-width: 480px){
        display:none;
    }`
}

${props => props.worldmenu && `
@media screen and (max-width: 850px){
    position: absolute;
    top: 5%;
}`
}

${props => props.communitymenu && `
top: 0px;
right: 10px;
z-index: 9;
`}

${props => props.moreCommunityStation && `
    top: -8px;
`}
${props => props.connectGift && `
`}

${props => props.mblstationDiv && `
@media only screen and (min-device-width : 750px) 
and (max-device-width : 1199px) and (orientation : portrait){ 
    padding-top: 50px;
    display:block;
    height:70vh;
}
@media only screen and (min-device-width : 750px) 
and (max-device-width : 1199px) and (orientation : landscape){ 
    padding-top: 30px;
    display:block;
    height:95vh;
}`
}
${props => props.myaccount && `
    min-width: 70%;
    padding: 29px 70px;
    @media screen and (max-width: 750px){
        width: 100%;
        padding: 29px 18px;
        background-color: #f3f3f3;
        }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px){
     width: 100%;
      background-color: #f3f3f3;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        background:none;
        margin-left: 12%;
    }`
}
${props => props.gethelp && `
    padding: 1% 3%;
    @media only screen and (min-device-width : 1400px) { 
    padding-top: 3%;
    }`
}
${props => props.accdetails && `
    margin-top: 5%;
 `
}
${props => props.emaildetails && `
    margin-top: 8%;
 `
}
${props => props.phonedetails && `
    margin-top: 48px;
 `
}
${props => props.editProfilePic && `
   display: flex;
   margin-top: 30px;
 `
}
${props => props.submitRequestDiv && `
   display: flex;
   margin-top: 30px;
   @media only screen and (max-width: 750px) {
    flex-flow:column;
   }`
}
${props => props.warninginfo && `
   display: flex;
   margin-top: 14px;
 `
}
${props => props.chooseDiv && `
    margin: 30px auto 16px auto;
    width: fit-content;
`
}
${props => props.btnDiv && `
    position:relative;
    display:flex;
    margin-left: auto;
    margin-top: 25px;
    right: 25px;
    @media screen and (max-width: 750px){
        right: 20%;
    }`
}

${props => props.addressdiv && `
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 50px;
    grid-row-gap: 27px;
`
}
${props => props.givemenu && `
    align-items: center;
    margin-left: auto;
    z-index: 1;
    position: relative;
    display: flex;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape)
    {
        & {
            margin-left: 0px;
        }
    }
`
}

${props => props.sendgift && `
    float:right;
    margin-top: 15px;
`
}

${props => props.worldmenu && `
`}


${props => props.fullflexdiv && `
    display: flex;
    width: 100%;
    @media screen and (max-width: 850px){
        flex-direction: column;
        overflow-x:clip;
        overflow-y:scroll;
        padding-bottom:15px;
    }`
}

${props => props.successwrapper && `
    width: 50%;
    margin-top: auto;
    margin-bottom: auto;
    @media screen and (max-width: 850px){
        width:100%;
    }`
}
${props => props.farewell && `
    width: 100%;
    margin: 1rem 0;
    @media screen and (max-width: 850px){
        width:100%;
    }`
}
${props => props.successleft && `
    width: 252px;
    margin: auto;
 `
}

${props => props.sentTrackerWrapper && `
    width: 47%;
    fill: linear-gradient(270deg, rgba(255, 255, 255, 0.00) 36.74%, #F9F9F9 90.00%);
    margin-top: 20px;
    @media screen and (max-width: 850px){
        width: 100%;
        margin-top: 0;
    }`
}
${props => props.verticalSeperator && `
    width: 3%;
    background: linear-gradient(270deg, rgba(255, 255, 255, 0.00) 36.74%, #F9F9F9 90.00%);
 `
}
${props => props.horizontalSeperator && `
    width: 100%; 
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin:1rem 0;
`}
${props => props.prefPadding && `
    padding-bottom: 32px;
    border-bottom: 1px solid #C9C9C9;
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        padding-bottom: 1em;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
    {
        padding-bottom: 1em;
    }`
}
${props => props.writeToChild && `
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    border: 1px solid #FF6B00;
    background-color: #fff;
    border-radius: 12px;
    position:relative;
    margin: 0 35px;
    cursor: pointer;
    padding: 15px 0;
`}

${props => props.powerClaims && `
    width: 90%;
    margin: 0 auto;
    height: auto;
    border-radius: 12px;
    bottom:7vh;
    border-radius: 10px;
    flex-shrink: 0;
    background: #FFF;
    border: 2px solid rgb(0,0,0,0.06);
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.06);

    @media screen and (max-width: 749px){
        width: 90%;
        margin: 10px 20px;
        box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.25);
        bottom: 4%;
    }
    @media screen and (min-width:750px) and (max-width: 1024px){
        width: 45%;
        margin: 10px 20px;
        box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, 0.25);
        bottom: 4%;
    }`
}

${props => props.privacydiv && `
    padding: 3% 10% 10% 8%;
    width: 70%;
    @media screen and (max-width: 850px){
        padding: 2% 5%;
        width: 100%;
      }`
}
${props => props.confirmButtons && `
    display: flex;
    margin-top: 5%;
    justify-content: center;
 `
}
${props => props.gethelpHeader && `
    margin-top: 15px;
    margin-left: 10px;
 `
}
${props => props.giftChildName && `
    justify-content: center
 `
}
${props => props.giftButton && `
    display: flex;
    justify-content: center
 `
}
${props => props.getHelpBtns && `
    display: flex;
    justify-content: center;
    margin: 10px;
    flex-flow:column;
    width:85%;
    margin-top:20%;
    @media screen and (max-width: 600px){
        flex-direction: column;
        margin-top: 10%;
    }
    @media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
    {
        margin-top:5%;
    }`
}
${props => props.gethelpnodata && `
    padding: 15% 0;
`
}
${props => props.bottomAligned && `
    position:absolute;
    bottom:7vh;
    @media screen and (max-width: 850px){   //added for mobile and tablet
        position: unset;
        padding: unset;
      }`
}
${props => props.stationFeedItem && `
    padding-top: 10px;
    width: 100%;
    padding-top: 15px;
`}
${props => props.stationNewTabFeed && `
    padding-bottom:1em;
    padding-top:0px;
    overflow:auto;
`}
${props => props.newFeed === "New" && `
    padding: 10px 10px 0 10px;
    border: 1px solid #E6E6E6;
    background: rgba(132, 187, 241, 0.2);
    border-radius: 12px;
    margin: 10px 0px;
    @media screen and (max-width: 850px){ 
    padding: 10px;
  }`
}
${props => props.worldClose && `
    margin-top: 13px;
    font-size:20px;
    margin-left:1rem;
    @media screen and (max-width: 850px){ 
        margin-top: 0px;
    }
    @media screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait){ 
        margin-top: 12px;
    }`
}
${props => props.profile && `
    align-items: end;
    position: relative;
    @media screen and (max-width: 750px){ 
        margin-top: 10px;
    }
    @media screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait){ 
        margin-top: 10px;
    }`
}
`;
export const PowerClaimsDiv  = styled(Div)`
  ${props => props.powerClaims && `
    @media screen and (min-width:750px) and (max-width: 1024px){
      width: 90%;
      position: absolute;
      right: 0px;
      bottom: 200px;
      z-index: 1;
    }
  `}
`;
export const PowerClaimsCommunityDiv  = styled(Div)`
  ${props => props.powerClaims && `
    @media screen and (min-width:750px) and (max-width: 1024px){
      width: 45%;
      position: absolute;
      right: 0px;
      bottom: 200px;
      z-index: 1;
    }
  `}
`;